import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { CoverActionsUnion, CoverActionTypes } from '@core/actions/cover.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State {
  covers: any,
  loading: boolean;
  loaded: boolean;
  busy: any;
}

export const INITIAL_STATE: State = {
  covers:{},
  loading: false,
  loaded: false,
  busy: false
};   

export function reducer(
  state: State = INITIAL_STATE,
  action: CoverActionsUnion
) {
  switch (action.type) {
    case CoverActionTypes.Load:
    case CoverActionTypes.Create:
    case CoverActionTypes.ExportGroupCoversUpdate:
      return { ...state, loading: true, busy: true };

    case CoverActionTypes.LoadFail:
    case CoverActionTypes.ExportGroupCoversSuccess:
    case CoverActionTypes.ExportGroupCoversFail:
      return { ...state, loading: false, busy: false };

    case CoverActionTypes.LoadSuccess:
      return { 
        ...state, 
        loading: false, 
        loaded: true,
        busy: false,
        covers: action.cover
      };

    default:
      return state;
  }
}

export const getState = createFeatureSelector<State>('cover');

export const getLoaded = createSelector(
  getState,
  (state: State) => state.loaded
);
export const getLoading = createSelector(
  getState,
  (state: State) => state.loading
);

export const getAll = createSelector(
  getState,
  (state: State) => state.covers
);

export const getBusyCover = createSelector(
  getState,
  (state: State) => state.busy
);